import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './components/notification/notification.component';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';

@NgModule({
  imports: [CommonModule, ToastModule],
  declarations: [NotificationComponent],
  exports: [NotificationComponent],
  providers: [MessageService],
})
export class SharedFeatureNotificationHandlingModule {}
